const cashierProcessing = "/cashier-processing";
const CASHIER_PROCESSING_WINDOW = "CASHIER_PROCESSING_WINDOW";
const isCashierProcessingPath = typeof window !== "undefined" ? window.location.pathname.includes(cashierProcessing) : false;
export {
  CASHIER_PROCESSING_WINDOW,
  cashierProcessing,
  isCashierProcessingPath
};
